import React from 'react';
import TextInput, {
  textInputPropTypes,
} from '../../common/molecules/TextInput';
import { KEYWORD_INPUT_ID } from '../../constants';
import useKeywordInputLogic from './useKeywordInputLogic';

const KEYWORD_INPUT_CONSTS = {
  ICON: 'keywordSearch',
  ID: KEYWORD_INPUT_ID,
  PLACEHOLDER: 'Search for a business...',
};

const KeywordInput = ({ className, maxResults, size }) => {
  const { handleChange, handleFocus } = useKeywordInputLogic({
    maxResults,
  });
  return (
    <TextInput
      handleChange={handleChange}
      handleFocus={handleFocus}
      className={className}
      icon={KEYWORD_INPUT_CONSTS.ICON}
      id={KEYWORD_INPUT_CONSTS.ID}
      placeholder={KEYWORD_INPUT_CONSTS.PLACEHOLDER}
      size={size}
    />
  );
};

const keywordInputPropTypes = {
  className: textInputPropTypes.className,
  size: textInputPropTypes.size,
};
const keywordInputDefaultProps = {
  className: undefined,
  size: undefined,
};
KeywordInput.propTypes = keywordInputPropTypes;
KeywordInput.defaultProps = keywordInputDefaultProps;

export default KeywordInput;
export {
  KEYWORD_INPUT_CONSTS,
  keywordInputDefaultProps,
  keywordInputPropTypes,
};
